import React, { useState } from "react";
import { Route, Redirect } from "react-router";
import { Layout } from "./components/Layout";
import { Home } from "./components/Home/Home";
import { ConfigFerrettiInfynito } from "./components/Home/ConfigFerrettiInfynito";
import { CustomizationContextProvider } from "./components/CustomizationContext";
import { LocalizationContextProvider } from "./components/LocalizationContext";
import { ModelContextProvider } from "./components/ModelContext";
import CssBaseline from "@mui/material/CssBaseline";

import LandingInfynito80 from "./components/Landing/Infynito80/LandingIndex";

import TagManager from 'react-gtm-module'



export const App = () => {

    // Google Analyytics

    const tagManagerArgs = {
        gtmId: 'GTM-5ZG3K7M' /* 'GTM-5ZG3K7M' */
    }
    TagManager.initialize(tagManagerArgs);


    return (
        <>
            <LocalizationContextProvider>
                <ModelContextProvider>
                    <CustomizationContextProvider>
                        <CssBaseline />
                        <Layout>
                            <Route exact path="/" component={Home} />
                            <Route exact path="/en-us/ConfiguratorFerrettiInfynito90" render={(props) => <ConfigFerrettiInfynito modelCode="Infynito90" cultureCode="en-us" indexStep={0} returnUrl="" />} />
                            <Route exact path="/it-it/ConfiguratorFerrettiInfynito90" render={(props) => <ConfigFerrettiInfynito modelCode="Infynito90" cultureCode="it-it" indexStep={0} returnUrl="" />} />
                            <Route exact path="/en-us/ConfiguratorFerrettiInfynito80" render={(props) => <ConfigFerrettiInfynito modelCode="Infynito80" cultureCode="en-us" indexStep={0} returnUrl="" />} />
                            <Route exact path="/it-it/ConfiguratorFerrettiInfynito80" render={(props) => <ConfigFerrettiInfynito modelCode="Infynito80" cultureCode="it-it" indexStep={0} returnUrl="" />} />
                            <Route exact path="/en-us/LandingInfynito80" render={(props) => <LandingInfynito80 modelCode="Infynito80" cultureCode="en-us" />} />
                            <Route exact path="/it-it/LandingInfynito80" render={(props) => <LandingInfynito80 modelCode="Infynito80" cultureCode="it-it" />} />
                            <Route exact path="/en-us/LandingInfynito80/:sectionId" render={(props) => <LandingInfynito80 modelCode="Infynito80" cultureCode="en-us" />} />
                            <Route exact path="/it-it/LandingInfynito80/:sectionId" render={(props) => <LandingInfynito80 modelCode="Infynito80" cultureCode="it-it" />} />
                            <Route exact path="/en-us/InteractiveConfiguratorFerrettiInfynito80" render={(props) => <ConfigFerrettiInfynito modelCode="Infynito80" cultureCode="en-us" indexStep={1} returnUrl="/en-us/LandingInfynito80" />} />
                            <Route exact path="/it-it/InteractiveConfiguratorFerrettiInfynito80" render={(props) => <ConfigFerrettiInfynito modelCode="Infynito80" cultureCode="it-it" indexStep={1} returnUrl="/it-it/LandingInfynito80" />} />
                            <Route exact path="/ClientApp">
                                <Redirect to="/" />
                            </Route>
                        </Layout>
                    </CustomizationContextProvider>
                </ModelContextProvider>
            </LocalizationContextProvider>
        </>
    );
};

export default App;
